import React from "react";
import { useGlobalStates } from "../../context/GlobalStates";
import { MdOutlineLightMode, MdOutlineDarkMode } from "react-icons/md";

const Navbar = () => {
	const image =
		"https://firebasestorage.googleapis.com/v0/b/other-project-data.appspot.com/o/sezar-secret-app%2Fsezar-image.webp?alt=media&token=9dd6b830-7cdf-4c52-9c59-3c1c8c718aaa";

	const { theme, setIsDarkMode, isDarkMode } = useGlobalStates();
	return (
		<dv className="flex w-screen bg-[#ccc5b9] justify-between md:justify-around items-center px-1 md:px-2 md:py-3 py-1 border">
			<div className="overflow-hidden cursor-pointer">
				<img
					alt="caesar image"
					className="w-16 rounded-full h-16 md:w-24 md:h-24 object-contain"
					src={image}
				/>
			</div>
			<div>
				<p className="md:text-4xl text-xl font-mono font-semibold">
					Caesar Secret Message
				</p>
			</div>
			<div
				onClick={() => setIsDarkMode(!isDarkMode)}
				className="cursor-pointer hover:scale-105 duration-150 transform"
			>
				{theme === "dark" ? (
					<MdOutlineDarkMode className="text-2xl md:text-4xl text-black" />
				) : (
					<MdOutlineLightMode className="text-2xl md:text-4xl text-white" />
				)}
			</div>
		</dv>
	);
};

export default Navbar;
